import Company from '@/models/loyaltyPanel/Company';
const getDefaultState = () => ({
  notificationsLoading: false,
  notifications: [],
  notificationsPagination: {},
  exportedFile: null,
  exportNotificationFileCreated: false,
});

export default {
  namespaced: true,

  state: () => getDefaultState(),
  getters: {
    notifications: (state) => state.notifications,
    exportedFile: (state) => state.exportedFile,
  },
  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setNotifications(state, payload) {
      state.notifications = payload;
    },
    setNotificationsLoading(state, payload) {
      state.notificationsLoading = payload;
    },
    setNotificationsPagination(state, payload) {
      state.notificationsPagination = payload;
    },
    setExportedFile(state, payload) {
      state.exportedFile = payload;
    },
    setExportNotificationFileCreated(state, payload) {
      state.exportNotificationFileCreated = payload;
    },
  },

  actions: {
    async getNotifications({ commit, getters, state }, payload) {
      try {
        commit('setLoading', true, { root: true });
        commit('setNotificationsLoading', true);

        const { data } = await Company.getNotifications(payload);

        const { user_notifications, pagination } = data.data;

        for (let i in user_notifications) {
          for (let p in user_notifications[i]) {
            user_notifications[i][p] = user_notifications[i][p] ? user_notifications[i][p] : '-';
          }
        }
        commit('setNotifications', user_notifications);
        commit('setNotificationsPagination', pagination);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },
  },
};
